import { FormlyFieldConfig } from '@ngx-formly/core';

export interface ServiceLayout {
  name: string;
  fieldGroup: FormlyFieldConfig[];
}

export interface ServiceFormGroup {
  fieldGroup: ServiceFormConfig[]
}

export interface ServiceFormConfig {
  key: string;
  type: string;
  props: {
    label: string;
    placeholder: string;
    required: boolean;
  };
}

export interface ServiceFormSection {
  className: string;
  template: string;
}
